import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router/router';
// VueX store removed - now using Pinia stores in @/stores

import vSelect from 'vue-select';

import 'vue-select/dist/vue-select.css';
import './css/index.css';

import ToggleButton from '@/components/ui/ToggleButton.vue';

// Create Vue 3 app
const app = createApp(App);

// Create Pinia store
const pinia = createPinia();

// Use plugins
app.use(pinia);
app.use(router);
// Note: Vue filters (Filters) have been migrated to utility functions in @/utils/formatter.js
// for Vue 3 compatibility. See Phase 1.4 of the refactoring plan.

// Register global components
app.component('v-select', vSelect);
app.component('toggle-button', ToggleButton);

// Mount app
app.mount('#app');
